export default "__VITE_ASSET__f1ffd619__"